module.exports = __webpack_public_path__ + "img/hr-stone-path-o.360d0e68.png";